import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Select, MenuItem } from "@mui/material";
import { sendTemplate } from "../api/actions/mutation";
import { useDispatch } from "react-redux";
import { messageShow } from "../../common/api/actions";

const TemplateSelectionPopup = ({ open, onClose, handleClose, contactId, templates, type }) => {
    const [selectedTemplate, setSelectedTemplate] = useState("");
    const dispatch = useDispatch()
    const closePopup = onClose || handleClose || (() => {});

    const handleSubmit = async () => {
        if (selectedTemplate) {
            try {
                const response = await sendTemplate({ templateId: selectedTemplate, userId: contactId, type });
                if(response.data?.success)    dispatch(messageShow('Mail Sent successfully'))
                else    dispatch(messageShow('Failed to send'))
                closePopup();
            } catch (err) {
                dispatch(messageShow(err.message))
                console.error("Failed to send template:", err);
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Select a Template to send Email</DialogTitle>
            <DialogContent>
                <Select
                    fullWidth
                    value={selectedTemplate}
                    onChange={(e) => setSelectedTemplate(e.target.value)}
                    displayEmpty
                >
                    <MenuItem value="" disabled>
                        Select a template
                    </MenuItem>
                    {(templates || []).filter(template => !template.isDefault).map((template) => (
                        <MenuItem key={template._id} value={template._id}>
                        {template.name}
                        </MenuItem>
                    ))}
                </Select>
            </DialogContent>
            <DialogActions>
                <Button onClick={closePopup} color="secondary">
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    disabled={!selectedTemplate}
                >
                    Send
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TemplateSelectionPopup;
